import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PAYMENT_OFFICER_ROLE } from './auth-roles';
import { KeycloakAuthService } from './keycloak-auth.service';
import { StorageService } from './storage.service';

export const paymentOfficerGuard: CanActivateFn = (_route, state) => {
  const keycloakAuth = inject(KeycloakAuthService);
  const router = inject(Router);
  const storageService = inject(StorageService);

  if (!keycloakAuth.isLoggedIn()) {
    storageService.saveRedirectUrl(state.url);
    return router.createUrlTree(['/account/login']);
  }

  if (keycloakAuth.hasRole(PAYMENT_OFFICER_ROLE)) {
    return true;
  }

  return router.createUrlTree(['/applications']);
};
